import React, { Fragment, useEffect, useRef } from "react";
import Name from "./join/Name";
import Phone from "./join/Phone";
import Gender from "./join/Gender";
import Residence from "./join/Residence";
import Recommend from "./join/Recommend";
import MemberShip from "./join/MemberShip";
import Personal from "./join/Personal";
import Marketing from "./join/Marketing";
import ThirdParty from "./join/ThirdParty";
import Birthday from "./join/Birthday";
import AllYn from "./join/AllYn";
import SaveIcon from "@material-ui/icons/Save";
import AdYn from "./join/AdYn";
import axios from "axios";
import Meta from "../lib/Meta";
import { url } from "../lib/Common";
import { useHistory } from "react-router-dom";

import { TableCell, withStyles, Button, makeStyles } from "@material-ui/core";
import CompanySite from "./join/CompanySite";
import CompanyName from "./join/CompanyName";

const useStyles = makeStyles((theme) => ({
  FormControlLabel: {
    fontSize: 10,
    marginBottom: -5,
  },
  TypographyFont: {
    fontSize: 12,
  },
  Button: { marginLeft: "auto" },
  FormLabel: {
    fontSize: 25,
    marginTop: 6,
    marginLeft: -20,
  },
  TextField: {
    marginTop: 10,
    marginBottom: 10,
  },
  RadioGroup: {
    marginLeft: 10,
  },
  TextFieldWith70: {
    width: "70%",
    marginTop: 10,
    marginBottom: 10,
  },
  FormLabelContorl: {
    display: "block",
    textAlign: "right",
    align: "right",
  },
  FormControl: {
    display: "block",
  },
}));

const FontTableCell = withStyles((theme) => ({
  body: {
    fontSize: 8,
  },
}))(TableCell);

function CompanyJoin({
  Join,
  onChangeName,
  onChangeBirthday,
  onChangeLunar,
  onChangePhone,
  onChangeGender,
  onChangeResidence,
  onChangeRecommend,
  onChangeMemberShip,
  onChangePersonal,
  onChangeMarketing,
  onChangeThirdParty,
  onChangeSmsYn,
  onChangeKakaoYn,
  onChangeAdYn,
  onChangePartDiv,
  onChangePartNo,
  partCode,
  onChangeTotalAllYn,
  onChangeAllYn,
  onChangeCompanyName,
  onChangeCompanySite,
}) {
  const history = useHistory();

  useEffect(() => {
    const urlPartCodeCheck = url + "/api/specialMember/partCodeCheck";
    axios
      .post(
        urlPartCodeCheck,
        {
          partCode: partCode,
        },
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.COUNT !== "1") history.push("/404");
        else {
          onChangePartDiv(partCode.substring(0, 1));
          onChangePartNo(partCode.substring(1, 5));
        }
      })
      .catch((_) => {
        history.push("/404");
      });
  }, [onChangePartDiv, onChangePartNo, partCode, history]);

  const phoneRef = useRef(null);
  const memberShipRef = useRef(null);
  const personalRef = useRef(null);
  const companyRef = useRef(null);

  const validateAd = () => {
    if (!Join.personal) {
      personalRef.current.focus();
      alert("개인정보 수집, 활용 동의는 필수입니다.");
      return false;
    } else if (!Join.memberShip) {
      memberShipRef.current.focus();
      alert("멤버십 이용 약관 동의는 필수입니다.");
      return false;
    } else if (!Join.companyName) {
      companyRef.current.focus();
      alert("회사명 입력은 필수입니다.");
      return false;
    }
    return true;
  };

  const memberJoin = () => {
    return new Promise(function (resolve, reject) {
      let urlJoin = url + "/api/specialMember/memberJoin";
      axios
        .post(
          urlJoin,
          {
            Join,
          },
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.errCode !== "0") {
            reject(response.data.errCode);
          } else {
            resolve(true);
          }
        })
        .catch((response) => {
          reject(-400);
        });
    });
  };
  let doubleSubmitFlag = false;
  const doubleSubmitCheck = () => {
    if (doubleSubmitFlag) {
      return doubleSubmitFlag;
    } else {
      doubleSubmitFlag = true;
      return false;
    }
  };
  const onValidate = () => {
    if (validateAd() === false) return false;
    return true;
  };
  const onSubmitHandler = (e) => {
    e.preventDefault(); // 아무 동작 안하고 버튼만 눌러도 리프레쉬 되는 것을 막는다
    if (doubleSubmitCheck()) return;
    if (onValidate() === false) return;

    memberJoin().then(
      function (value) {
        if (value === true) {
          history.push("/success"); // push() 또는 replace() 사용
          return;
        } else {
          alert("가입 실패.");
          return;
        }
      },
      function (error) {
        switch (error) {
          case "-1":
            alert(
              "만 14세미만 가입 불가합니다.멤버십 약관(제4조3항)을 참조하세요~"
            );
            return;
          case "-2":
            alert(
              "휴대폰 번호 중복(CRM팀으로 문의 주세요! 02-3274-6495 / 6238)"
            );
            return;
          case "-3":
            alert("맴버아이디 , 마일리지 카드번호 채번중 오류");
            return;
          case "-4":
            alert("고객마스터 등록중 오류발생");
            return;
          case "-5":
            alert("포인트 지급 중 오류 발생");
            return;
          case "-400":
            alert("서버 호출 에러");
            return;
          default:
            alert("에러 호출번호 오류!!!!" + error);
            return;
        }
      }
    );
  };
  const metaData = {
    image: "%PUBLIC_URL%/logo192.png",
    title: "신원 특판 회원가입",
    description: "신원 특판 회원가입페이지입니다.",
    width: "192",
    height: "192",
    canonical: `crm/join/${partCode}`,
  };
  return (
    <Fragment>
      <Meta data={metaData} />
      <form onSubmit={onSubmitHandler}>
        <Name
          name={Join.name}
          onChangeName={onChangeName}
          useStyles={useStyles}
        ></Name>
        <Birthday
          lunar={Join.lunar}
          birthday={Join.birthday}
          onChangeBirthday={onChangeBirthday}
          onChangeLunar={onChangeLunar}
          useStyles={useStyles}
        ></Birthday>
        <Phone
          url={url}
          phone={Join.phone}
          onChangePhone={onChangePhone}
          useStyles={useStyles}
          phoneRef={phoneRef}
        ></Phone>
        <Gender
          gender={Join.gender}
          onChangeGender={onChangeGender}
          useStyles={useStyles}
        ></Gender>
        <CompanyName
          companyName={Join.companyName}
          onChangeCompanyName={onChangeCompanyName}
          companyRef={companyRef}
          useStyles={useStyles}
        ></CompanyName>
        <CompanySite
          companySite={Join.companySite}
          onChangeCompanySite={onChangeCompanySite}
          useStyles={useStyles}
        ></CompanySite>
        <Recommend
          url={url}
          phone={Join.phone}
          phoneRef={phoneRef}
          recommend={Join.recommend}
          onChangeRecommend={onChangeRecommend}
          useStyles={useStyles}
        ></Recommend>
        <Residence
          residence={Join.residence}
          onChangeResidence={onChangeResidence}
          useStyles={useStyles}
        ></Residence>

        <h3>* 표시 정보는 필수 기재 항목입니다.</h3>
        <AllYn
          totalAllYn={Join.totalAllYn}
          onChangeTotalAllYn={onChangeTotalAllYn}
          FontTableCell={FontTableCell}
          useStyles={useStyles}
        />
        <MemberShip
          memberShip={Join.memberShip}
          onChangeMemberShip={onChangeMemberShip}
          memberShipRef={memberShipRef}
          useStyles={useStyles}
          history={history}
        />
        <Personal
          personal={Join.personal}
          onChangePersonal={onChangePersonal}
          personalRef={personalRef}
          useStyles={useStyles}
          FontTableCell={FontTableCell}
        />
        <Marketing
          marketing={Join.marketing}
          onChangeMarketing={onChangeMarketing}
          useStyles={useStyles}
        />
        <ThirdParty
          thirdParty={Join.thirdParty}
          onChangeThirdParty={onChangeThirdParty}
          useStyles={useStyles}
          FontTableCell={FontTableCell}
        />
        <AdYn
          smsYn={Join.smsYn}
          kakaoYn={Join.kakaoYn}
          adYn={Join.adYn}
          allYn={Join.allYn}
          onChangeAllYn={onChangeAllYn}
          onChangeSmsYn={onChangeSmsYn}
          onChangeKakaoYn={onChangeKakaoYn}
          onChangeAdYn={onChangeAdYn}
          useStyles={useStyles}
          FontTableCell={FontTableCell}
        />
        <hr></hr>
        <Button
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          fullWidth
          startIcon={<SaveIcon />}
        >
          가입하기
        </Button>
      </form>
    </Fragment>
  );
}
export default CompanyJoin;
